package com.eladfinish.bible.contest.features.installTime.di

import com.eladfinish.bible.contest.ads.GetAdFreeStateUseCase
import com.eladfinish.bible.contest.ads.ShouldShowAdsUseCase
import com.eladfinish.bible.contest.currentMilliseconds
import com.eladfinish.bible.contest.features.installTime.domain.config.TimeGateConfig
import com.eladfinish.bible.contest.features.installTime.domain.repository.DefaultInstallInfoRepository
import com.eladfinish.bible.contest.features.installTime.domain.repository.InstallInfoRepository
import com.eladfinish.bible.contest.features.installTime.domain.usecase.TimeGateUseCase
import org.koin.dsl.module
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
val installTimeModule = module {

    /* ----------------------------
     * Repository
     * ---------------------------- */

    single<InstallInfoRepository> {
        DefaultInstallInfoRepository(
            provider = get()
        )
    }

    /* ----------------------------
     * Config
     * ---------------------------- */

    factory {
        TimeGateConfig(
            enabled = true,
            minutesSinceInstall = 24,
            minutesSinceUpdate = 0,
        )
    }

    /* ----------------------------
     * UseCases
     * ---------------------------- */

    factory {
        TimeGateUseCase(
            repository = get(),
            defaultConfig = get(),
            nowMillis = { currentMilliseconds }
        )
    }

    factory {
        ShouldShowAdsUseCase(
            settings = get(),
        )
    }

    factory {
        GetAdFreeStateUseCase(
            settings = get(),
        )
    }

    includes(installTimePlatformModule)
}
